import { Component, Input, NgModule} from '@angular/core';

@Component({
  selector: 'app-bg-primary-text',
  templateUrl: './bg-primary-text.component.html',
  styleUrls: ['./bg-primary-text.component.scss']
})
export class BgPrimaryTextComponent {
    @Input() bgPrimaryTitle: string = '';
    @Input() bgPrimaryText: string = '';
    @Input() bgPrimaryTextSecond: string = '';
    @Input() bgPrimaryTextThirst: string = '';

}
